import { render, staticRenderFns } from "./_Tab.vue?vue&type=template&id=9c58852c&lang=pug&"
import script from "./_Tab.vue?vue&type=script&lang=ts&"
export * from "./_Tab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports